/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  CashBalanceDetails,
  FailureResponseResponse,
  NotFoundResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Returns last cash balance declaration of an accounting location
 * @summary Get latest cash declaration of an accounting location
 */
export const getLatestCashDeclaration = (accountingLocationID: string, signal?: AbortSignal) => {
  return customInstance<CashBalanceDetails>({
    url: `/BboCashManagementService/v1/cash-declaration/accounting-location/${accountingLocationID}`,
    method: 'get',
    signal,
  });
};

export const getGetLatestCashDeclarationQueryKey = (accountingLocationID: string) => {
  return [
    `/BboCashManagementService/v1/cash-declaration/accounting-location/${accountingLocationID}`,
  ] as const;
};

export const getGetLatestCashDeclarationQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestCashDeclaration>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  accountingLocationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLatestCashDeclaration>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLatestCashDeclarationQueryKey(accountingLocationID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestCashDeclaration>>> = ({
    signal,
  }) => getLatestCashDeclaration(accountingLocationID, signal);

  return { queryKey, queryFn, enabled: !!accountingLocationID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestCashDeclaration>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLatestCashDeclarationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLatestCashDeclaration>>
>;
export type GetLatestCashDeclarationQueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Get latest cash declaration of an accounting location
 */
export const useGetLatestCashDeclaration = <
  TData = Awaited<ReturnType<typeof getLatestCashDeclaration>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  accountingLocationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLatestCashDeclaration>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLatestCashDeclarationQueryOptions(accountingLocationID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
